import { render } from "./PedidosVendidoVsConfirmado.vue?vue&type=template&id=76e63b03&scoped=true"
import script from "./PedidosVendidoVsConfirmado.vue?vue&type=script&lang=ts"
export * from "./PedidosVendidoVsConfirmado.vue?vue&type=script&lang=ts"

import "./PedidosVendidoVsConfirmado.vue?vue&type=style&index=0&id=76e63b03&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76e63b03"

export default script